import axios from "axios";
export const apiClient=axios.create({
    baseURL:process.env.REACT_APP_API_Url
});

export const ssoClient=axios.create({
    baseURL:process.env.REACT_APP_API_SsoUrl
});


export const omrehBaseClient=axios.create({
    baseURL:process.env.REACT_APP_API_OmrehBaseUrl
});

export const assignmentClient=axios.create({
    baseURL:process.env.REACT_APP_API_Assignment
});


apiClient.interceptors.request.use((request) => {
    const token = localStorage.getItem("token") ?? null;
    request.headers.Authorization = `Bearer ${token}`
    return request;
});

ssoClient.interceptors.request.use((request) => {
    const token = localStorage.getItem("token") ?? null;
    request.headers.Authorization = `Bearer ${token}`
    return request;
});
omrehBaseClient.interceptors.request.use((request) => {
    const token = localStorage.getItem("token") ?? null;
    request.headers.Authorization = `Bearer ${token}`
    return request;
});
